/**
 * Javascript file for the confidentiality information page.
 * @author Adrian Rebmann, Yannik Sprengart
 */

export default {
  name: "Confidentiality",

  /**
   * The vue instance's data object.
   * @property {string} msg - The platform's name.
   */
  data() {
    return {
      msg: "WERNER"
    };
  }
};



// WEBPACK FOOTER //
// ./src/components/datasecurity/confidentiality/confidentiality.js